import React, { Suspense, useEffect, useRef, useState } from 'react';
import { Panel } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import withAuthentication from '../../hoc/withAuthentication';
import withLayout from '../../hoc/withLayout';

import { breadcrumbAddRoute } from '../../store/actions/breadcrumb';
import Permission from '../../components/Permission/Permission';
import { useFranchiseStore } from '../../store/providers/Franchise';
import { useStateStore } from '../../store/providers/State';
import { useTerritoryStore } from '../../store/providers/Territory';
import { useBranchOfficeStore } from '../../store/providers/BranchOffice';
import { useZipcodeStore } from '../../store/providers/Zipcode';

import * as constants from '../../constants';
import _ from 'lodash';
import { Form, Row, Button } from 'react-bootstrap';
import { columns, sorting } from './TerritoryListSchema';

import Multiselect from 'multiselect-react-dropdown';
import InputCollection from '../../components/InputCollection/InputCollection';
import withForm from '../../hoc/withForm';
import BaseList from '../../components/Lists/BaseList/BaseList';
import PageHeader from '../../components/PageHeader/PageHeader';
import DynamicMap from '../../components/Maps/TerritoryMap/DynamicMap';
import SideMenu from '../../components/SideMenu/SideMenu';
import Spinner from '../../components/Spinner/Spinner';

function Territories(props) {

    const dispatch = useDispatch();

    const { listRecords: franchiseList, data: franchiseData } = useFranchiseStore();
    const { listRecords: franchiseStatesList, data: franchiseStatesData } = useStateStore();
    const { listZipcodesByStates, listZipcodesByFranchises, data: territoryData } = useTerritoryStore();
    const { listAllRecords, data: listOfficeData } = useBranchOfficeStore();
    const { listStatisticByState, data: statisticsData } = useZipcodeStore();

    const [isMounted, setIsMounted] = useState(false);

    const pagePermission = constants.PERMISSION_TERRITORYMAP;
    const [hasPermission, setHasPermission] = useState(false);
    const [canEdit, setCanEdit] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);

    const [territoryList, setTerritoryList] = useState([]);
    const [mapData, setMapData] = useState([]);
    const [officeData, setOfficeData] = useState([]);
    const [officeDataSubmission, setOfficeDataSubmission] = useState([]);
    const [statistics, setStatistics] = useState([]);

    const [franchiseOptions, setFranchiseOptions] = useState([]);
    const [selectedFranchises, setSelectedFranchises] = useState([]);
    const franchiseDropdown = useRef(null);

    const [stateOptions, setStateOptions] = useState([]);
    const [selectedStates, setSelectedStates] = useState([]);
    const stateDropdown = useRef(null);

    const [isBusy, setIsBusy] = useState(false);
    const [isOfficeBusy, setIsOfficeBusy] = useState(false);
    const [initialCenter] = useState({ lat: 33.6408105, lng: -111.8976953 });

    const selectHandler = (list, _item) => {
        updateForm(list);
    };

    const removeHandler = (list, _item) => {
        updateForm(list);
    };

    const updateForm = (list) => {
        let franchiseIds = [];
        let franchiseInstances = [];

        if (!_.isEmpty(list)) {
            list.forEach((franchise) => franchiseIds.push(franchise.id));
            list.forEach((franchise) => franchiseInstances.push(franchise.instance));
        }

        setSelectedFranchises(list);
        props.formChanged('franchiseIds', franchiseIds);

        setSelectedStates([]);
        props.formChanged('stateIds', []);
        stateDropdown.current.resetSelectedValues();
    }

    const selectStateHandler = (list, _item) => {
        updateStateForm(list);
    };

    const removeStateHandler = (list, _item) => {
        updateStateForm(list);
    };

    const updateStateForm = (list) => {
        let stateIds = [];

        if (!_.isEmpty(list)) {
            list.forEach((state) => stateIds.push(state.id));
        }

        props.formChanged('stateIds', stateIds);
        setSelectedStates(list);
        setSelectedFranchises([]);
        props.formChanged('franchiseIds', []);
        franchiseDropdown.current.resetSelectedValues();
    }

    const submittedHandler = (e) => {
        e.preventDefault();
        setIsBusy(true);

        if (selectedStates && selectedStates.length > 0) {
            let stateArray = [];
            selectedStates.forEach((s) => {
                stateArray.push(s.id)
            })

            listZipcodesByStates({ states: stateArray.join(",") });
            listStatisticByState({ states: stateArray.join(",") });
        }

        if (selectedFranchises && selectedFranchises.length > 0) {
            let franchiseArray = [];
            let franchiseStates= [];
            selectedFranchises.forEach((s) => {
                franchiseArray.push(s.id)
                franchiseStates.push(s.state)
            })
            listZipcodesByFranchises({ franchiseIds: franchiseArray.join(",") });
            listStatisticByState({ states: franchiseStates.join(",") });
        }
    };

    const refreshedHandler = () => {

        setTerritoryList([]);
        setIsBusy(true);

        if (selectedStates && selectedStates.length > 0) {
            setIsOfficeBusy(true);

            let stateArray = [];
            selectedStates.forEach((s) => {
                stateArray.push(s.id)
            })

            listZipcodesByStates({ states: stateArray.join(",") });
            listStatisticByState({ states: stateArray.join(",") });
        }

        if (selectedFranchises && selectedFranchises.length > 0) {
            setIsOfficeBusy(true);
            let franchiseArray = [];
            selectedFranchises.forEach((s) => {
                franchiseArray.push(s.id)
            })

            listZipcodesByFranchises({ franchiseIds: franchiseArray.join(",") });

        }
    };

    useEffect(() => {
        if (hasPermission) { return; }
        if (isMounted) { return; }
        franchiseList();
        franchiseStatesList();
        listAllRecords();

        props.formInitialize({ franchiseIds: [] });
        props.formInitialize({ stateIds: [] });

        setIsMounted(true);
    }, [
        props,
        hasPermission,
        isMounted,
        dispatch
    ]);

    useEffect(() => {
        if (!_.isEmpty(franchiseData) && franchiseData.scope === 'list' && franchiseData.status === 'success') {
            const options = franchiseData.body.sort((a, b) => a.instance > b.instance ? 1 : -1).map((franchise) => {
                return { id: franchise.id, name: `${franchise.name} (${franchise.instance})`, instance: franchise.instance, state: franchise.stateId }
            });
            setFranchiseOptions(options);
        }
    }, [franchiseData]);

    useEffect(() => {
        if (!_.isEmpty(franchiseStatesData) && franchiseStatesData.scope === 'list' && franchiseStatesData.status === 'success') {
            const options = franchiseStatesData.body.map((state) => {
                return { id: state.id, name: `${state.name}` }
            });
            setStateOptions(options);
        }
    }, [franchiseStatesData]);

    useEffect(() => {
        if (!_.isEmpty(territoryData)) {

            if (!_.isEmpty(territoryData) && (territoryData.scope === 'listZipcodesStates' || territoryData.scope === 'listZipcodesFranchises') && territoryData.status === 'success') {
                let tlist = [];
                let mdata = [];
                territoryData.body.Page.forEach((a) => {
                    const polysJson = eval(a.PolygonBoundaries);

                    if (Array.isArray(a.Territories) && a.Territories.length) {
                        
                        if (selectedFranchises.length > 0) {
                            selectedFranchises.forEach((franchise) => {
                                for (const territory of a.Territories) {
                                    if(territory.Franchise.Id === franchise.id){
                                        tlist.push({
                                            id: a.Code+'_'+territory.Id,
                                            Zipcode: a.Code,
                                            InternalId: territory.Franchise.InternalId,
                                            TerritoryTypeId: territory.TerritoryTypeId,
                                            BranchOffice: territory.BranchOffice.Name,
                                            Territory: territory,
                                            Deleted: territory.Deleted,
                                            Active: !territory.Deleted
                                        });
                                    }
                                }
                            })
                        }

                        if (selectedFranchises.length === 0) {
                            for (const territory of a.Territories) {
                                tlist.push({
                                    id: a.Code+'_'+territory.Id,
                                    Zipcode: a.Code,
                                    InternalId: territory.Franchise.InternalId,
                                    TerritoryTypeId: territory.TerritoryTypeId,
                                    BranchOffice: territory.BranchOffice.Name,
                                    Territory: territory,
                                    Deleted: territory.Deleted,
                                    Active: !territory.Deleted
                                });
                            }
                        }


                    }

                    const activeTerritory = a.Territories.find(territory => { return territory.Deleted === null || territory.Deleted === false })
                    mdata.push({
                        Zipcode: a.Code,
                        State: a.State,
                        Franchise: activeTerritory?.Franchise ?? '',
                        BranchOffice: activeTerritory?.BranchOffice ?? '',
                        PolygonBoundaries: polysJson
                            ? polysJson
                            : '',
                        TerritoryTypeId: activeTerritory?.TerritoryTypeId ?? '',
                        Multi: a.HasMultipleBoundaries
                    });

                })
                setTerritoryList(tlist);
                setMapData(mdata);
            }

            setIsBusy(territoryData.status === 'processing' && (territoryData.scope === 'listZipcodesStates' || territoryData.scope === 'listZipcodesFranchises'));
        }
    }, [territoryData]);

    useEffect(() => {
        if (!_.isEmpty(statisticsData)) {

            if (!_.isEmpty(statisticsData) && statisticsData.scope === 'listStatisticByState' && statisticsData.status === 'success') {
                setStatistics(statisticsData.body);
            }

            setIsBusy(statisticsData.status === 'processing' && statisticsData.scope === 'listStatisticByState');
        }
    }, [statisticsData]);

    useEffect(() => {
        if (!_.isEmpty(listOfficeData)) {
            if (!_.isEmpty(listOfficeData) && listOfficeData.scope === 'listAll' && listOfficeData.status === 'success') {
                setOfficeData(listOfficeData.body);
            }
            setIsOfficeBusy(listOfficeData.status === 'processing' && (listOfficeData.scope === 'listAll'));
        }
    }, [listOfficeData]);

    useEffect(() => {
        if (!_.isEmpty(officeData)) {
            if (!_.isEmpty(selectedFranchises) && selectedFranchises && selectedFranchises.length > 0) {
                let officeArray = [];
                officeData.forEach((o) => {
                    if (o.active == true && selectedFranchises.some(sf => sf.id === o.franchiseId)) {
                        officeArray.push(o);
                    }
                    setOfficeDataSubmission(officeArray);
                })
            } else if (!_.isEmpty(selectedStates) && selectedStates && selectedStates.length > 0) {
                let officeArray = [];
                officeData.forEach((o) => {
                    if (o.active == true &&
                        selectedStates.some(st => st.id === o.stateId) &&
                        !officeArray.some(oa => oa.id === o.id)) {
                        officeArray.push(o);
                    }
                    setOfficeDataSubmission(officeArray);
                })
            }
        }
    }, [officeData, selectedFranchises, selectedStates]);



    dispatch(breadcrumbAddRoute({
        key: 'territories',
        text: 'Territory Map',
        path: window.location.pathname
    }));

    return (
        <>
            <SideMenu activeKey="territories" />
            <div className="content-body">
                <Permission showDenied={true} pagePermission={pagePermission} hasPermission={hasPermission} setHasPermission={setHasPermission} setCanEdit={setCanEdit} />

                {hasPermission && isMounted &&
                    <Suspense fallback={<Suspense text="Loading..." />}>
                        <PageHeader title="Territory Map" />
                        <div style={{ paddingRight: '15px' }}>
                            <Panel>
                                <Panel.Body>
                                    <>
                                        <Form onSubmit={(e) => submittedHandler(e)}>
                                            <Row>
                                                <div className="col-md-6">
                                                    <InputCollection labelText="Filter By State(s) (limit 3)" errorMessage={props.formValidationCheck('stateIds')}>
                                                        <Multiselect options={stateOptions} avoidHighlightFirstOption={true} displayValue="name" selectionLimit={3} disabled={isBusy} placeholder="Select States..." emptyRecordMsg="No States Available" selectedValues={selectedStates} ref={stateDropdown} onSelect={(list, item) => selectStateHandler(list, item)} onRemove={(list, item) => removeStateHandler(list, item)} />
                                                    </InputCollection>
                                                </div>

                                                <div className="col-md-6">
                                                    <InputCollection labelText="Filter By Instance(s) (limit 5)" errorMessage={props.formValidationCheck('franchiseIds')}>
                                                        <Multiselect options={franchiseOptions} avoidHighlightFirstOption={true} displayValue="name" selectionLimit={5} disabled={isBusy} placeholder="Select Instances..." emptyRecordMsg="No Instances Available" selectedValues={selectedFranchises} ref={franchiseDropdown} onSelect={(list, item) => selectHandler(list, item)} onRemove={(list, item) => removeHandler(list, item)} />
                                                    </InputCollection>
                                                </div>
                                            </Row>
                                            <Row>
                                                <div className="col-md-12 " style={{ display: 'flex', flexBasis: '40px', alignItems: 'center', justifyContent: 'center' }}>
                                                    <div className="form-action-buttons">
                                                        <Button bsStyle="danger" variant="danger" type="submit" className="button-group-margin" disabled={isDisabled || isBusy}>
                                                            <i className="fa fa-save button-icon"></i>
                                                            {isBusy ? 'Filtering...' : 'Filter Territories'}
                                                        </Button>
                                                    </div>
                                                </div>
                                            </Row>
                                        </Form>
                                        <hr className="form-divider" />
                                        {mapData && mapData.length > 0 && isOfficeBusy &&
                                            <div style={{ width: '100%', textAlign: 'center' }}><Spinner text="Loading Map..." /></div>
                                        }
                                        {mapData && mapData.length > 0 && !isOfficeBusy &&
                                            <DynamicMap
                                                key="dynamic-map"
                                                id="dynamic-map"
                                                selectedFranchises={selectedFranchises}
                                                mapData={mapData}
                                                statistics={statistics}
                                                officeData={officeDataSubmission}
                                                disableSubmission={(disableValue) => setIsDisabled(disableValue)}
                                                initialCenter={initialCenter}
                                            ></DynamicMap>
                                        }

                                        {mapData && mapData.length > 0 && territoryList && territoryList.length > 0 &&
                                            <div style={{ paddingTop: '30px' }}>
                                                <BaseList
                                                    compType="Territory"
                                                    listData={_.isEmpty(territoryList) ? null : territoryList}
                                                    isBusy={isBusy}
                                                    sorting={sorting}
                                                    columns={columns}
                                                    permissionEdit={canEdit}
                                                    hideCopy={true}
                                                    hideEdit={true}
                                                    hideAdd={true}
                                                    hideDelete={true}
                                                    hideRefresh={false}
                                                    hidePrint={true}
                                                    activeValue={true}
                                                    activeField="Active"
                                                    refreshed={() => refreshedHandler()}
                                                />
                                            </div>
                                        }
                                    </>
                                </Panel.Body>
                            </Panel>
                        </div>
                    </Suspense>
                }
            </div>
        </>
    );

};

export default withAuthentication(withLayout(withForm(Territories)));